<template>
  <v-container>
    <v-skeleton-loader v-if="$apollo.loading || !article" type="card-heading, list-item, image@2, list-item-three-line@5" />
    <v-card v-else class="pa-5">
      <h3 class="text-h3 mb-10">
        <v-text-field v-model="article.name" />
      </h3>
      <div>
        <v-chip>ID: {{ article.id }}</v-chip>
        <v-chip>
          Статус:
          <v-select
            v-model="article.status"
            :items="statusList"
          />
        </v-chip>
        <v-chip>Категория: {{ article.category.name }}</v-chip>
        <v-chip>Дата создания: {{ formatTimestamp(article.createdAt) }}</v-chip>
      </div>
      <v-divider class="my-7" />
      Превью
      <file-input :value="article.previewImage" bucket="image" :single-mode="true" :no-click-url="true" @change="setPreviewImage" />
      Картинка
      <file-input :value="article.image" bucket="image" :single-mode="true" @change="setImage" />
      <p class="text-h5 mt-5">
        Краткое описание:
      </p>
      <Editor
        v-model="article.shortDescription"
        api-key="2rxcw1a4wde19wtavegjogc47350tsb5koqh0u6adxik36sv"
        :init="{
          plugins: 'lists link image table code help wordcount',
          valid_children : '+body[style]',
        }"
      />
<!--      <Editor v-model="article.shortDescription" @change="val => article.shortDescription = val" />-->
      <p class="text-h5 mt-5">
        Контент:
      </p>
      <Editor
        v-model="article.fullDescription"
        api-key="2rxcw1a4wde19wtavegjogc47350tsb5koqh0u6adxik36sv"
        :init="{
          plugins: 'lists link image table code help wordcount',
          valid_children : '+body[style]',
        }"
      />
<!--      <Editor v-model="article.fullDescription" @change="val => article.fullDescription = val" />-->
      <p class="text-h5 mt-5">
        Meta title:
      </p>
      <v-text-field
        v-model="article.metaTitle"
        label="Meta title"
      />
      <p class="text-h5 mt-5">
        Meta description:
      </p>
      <v-textarea
        v-model="article.metaDescription"
        label="Meta description"
      />
      <v-btn color="green darken-1" @click="save">
        Сохранить
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>

import Editor from '@tinymce/tinymce-vue'
import { article, updateArticle } from '@/graphql/articles'
import FileInput from '@/components/articles/FileInput'
// import Editor1 from '~/components/core/Editor'

export default {
  name: 'Article',
  components: { Editor, FileInput },
  layout: 'dashboard',
  data () {
    return {
      timeProps: {
        format: '24hr'
      },
      statusList: [
        { value: 'PUBLISHED', text: 'Опубликован' },
        { value: 'DRAFT', text: 'В проекте' },
        { value: 'ARCHIVED', text: 'Отображать в меню' },
        { value: 'DELETED', text: 'Удален' }
      ],
      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        underline: true, // 下划线
        strikethrough: true, // 中划线
        mark: true, // 标记
        superscript: true, // 上角标
        subscript: true, // 下角标
        quote: true, // 引用
        ol: true, // 有序列表
        ul: true, // 无序列表
        link: true, // 链接
        imagelink: true, // 图片链接
        code: true, // code
        table: true, // 表格
        fullscreen: true, // 全屏编辑
        readmodel: true, // 沉浸式阅读
        htmlcode: true, // 展示html源码
        help: true, // 帮助
        /* 1.3.5 */
        undo: true, // 上一步
        redo: true, // 下一步
        trash: true, // 清空
        save: true, // 保存（触发events中的save事件）
        /* 1.4.2 */
        navigation: true, // 导航目录
        /* 2.1.8 */
        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true, // 右对齐
        /* 2.2.1 */
        subfield: true, // 单双栏模式
        preview: true // 预览
      }
    }
  },
  apollo: {
    article: {
      query: article,
      result ({ data, loading }) {
        if (data !== undefined && data.article !== null) {
          this.article = data.article
        }
      },
      variables () {
        return {
          id: Number(this.$route.params.id)
        }
      }
    }
  },
  beforeDestroy () {
    this?.editor?.destroy()
  },
  methods: {
    setImage (val) {
      this.article.image = val
    },
    setPreviewImage (val) {
      this.article.previewImage = val
    },
    formatTimestamp (timestamp) {
      return new Date(timestamp * 1000).toLocaleString('ru-RU')
    },
    save () {
      const data = Object.assign({}, this.article)
      data.image = Array.isArray(data.image) ? data.image[0] : data.image
      data.previewImage = Array.isArray(data.previewImage) ? data.previewImage[0] : data.previewImage
      delete data?.image?.__typename
      delete data?.previewImage?.__typename
      data.image.key = data?.image?.file?.key
      delete data?.image?.file
      data.previewImage.key = data?.previewImage?.file?.key
      delete data?.previewImage?.file
      delete data.id
      delete data.category
      delete data.createdAt
      delete data.__typename
      this.$apollo
          .mutate({
            mutation: updateArticle,
            variables: {
              id: Number(this.$route.params.id),
              input: data
            }
          })
          .then((data) => {
            this.$router.go({ name: 'articles' })
          })
          .catch((error) => {
            console.error(error)
          })
    }
  }
}
</script>

<style scoped>

</style>
